// 更新基本信息
export const SET_INFORMATION = 'SET_INFORMATION';
// 更新列表
export const SET_LIST = 'SET_LIST';
// 更新公司信息
export const SET_COMPANY = 'SET_COMPANY';
